import React, { useState, useEffect } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  customTable: {
    "& .MuiTableCell-sizeSmall": {
      padding: "5px 0px 5px 0px" // <-- arbitrary value
    }
  },
});


type Trade = {
  symbol: string;
  curPrice: string;
  entryPrice: number;
  orderType: string;
  profit: number;
  time:string;
};

type Props = {
  openPositions: Trade[];
  usdt_price:number
};

const TradeTable: React.FC<Props> = ({ openPositions, usdt_price }) => {
  const [trades, setTrades] = useState<Trade[]>([]);
  const classes = useStyles();

  useEffect(() => {
    setTrades(openPositions);
  }, [openPositions]);

  return (
    <Table classes={{root: classes.customTable}} size="small">
      <TableHead>
        <TableRow>
        <TableCell className="dark:text-white">시간</TableCell>
          <TableCell className="dark:text-white">거래페어</TableCell>
          <TableCell className="dark:text-white">손익(만원)</TableCell>
          <TableCell className="dark:text-white">매수가($)</TableCell>
          <TableCell className="dark:text-white">매도가($)</TableCell>
          <TableCell className="dark:text-white">주문 방향</TableCell>

        </TableRow>
      </TableHead>
      <TableBody>
        {trades.map((trade, i) => (
          <TableRow key={i}>
            <TableCell className="dark:text-white">{trade.time}</TableCell>
            <TableCell className="dark:text-white">{trade.symbol}</TableCell>
            <TableCell className="dark:text-white">{(usdt_price*trade.profit/ 10000).toFixed(1)}</TableCell>
            <TableCell className="dark:text-white">{trade.entryPrice}</TableCell>
            <TableCell className="dark:text-white">{trade.curPrice}</TableCell>
            <TableCell className="dark:text-white">{trade.orderType}</TableCell>           
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default TradeTable;
